import type { ExcludedReason } from './types';

/** Wording the contract requires verbatim (docs/benefits-deductions-contract.md), kept in one place so the screens, the tests and the guide agree. */

/** The three statements on the benefit form. */
export const BENEFIT_FORM_WARNINGS = [
  'Selecting a benefit does not automatically create a payroll deduction.',
  'This setting does not enroll an employee with an insurance carrier.',
  'Tax treatment must be approved before this deduction can be used in payroll.',
];

/** The two statements on the custom deduction form. */
export const DEDUCTION_FORM_WARNINGS = [
  'Custom deductions are not automatically pre-tax.',
  'Tax treatment must be approved before this deduction can be used in payroll.',
];

export const GARNISHMENT_RULES_NOTE = 'Garnishment limits and priorities are controlled by applicable rules.';

export const ELIGIBILITY_NOTE =
  'Phase 1 eligibility means active employees. There is no eligibility-rule engine yet, so every employee whose status is Active counts as eligible.';

export const NO_CALCULATION_NOTE = 'Percentage and other calculation types cannot be activated yet. Payroll honors only fixed amounts.';

export const EXCLUDED_REASON_TEXT: Record<ExcludedReason, string> = {
  AlreadyAssigned: 'Already has this deduction',
  NotInCompany: 'Not an employee of this company',
  NotActive: 'Not an active employee',
  HiredAfterEffectiveDate: 'Hired after the effective date',
  Duplicate: 'Chosen more than once',
};
